import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BlurText from '../components/BlurText';
import '../styles/RequestDemo.css';
import { trackEvent } from '../components/Analytics';
import platesImage from '../assets/plates.png'; // Add this import line

const RequestDemo = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        phoneNumber: '',
        demoDetails: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);
        setErrorMessage('');

        try {
            console.log('[DEMO] Submitting demo request form');
            
            // Send data to backend API
            const response = await fetch('https://sophie-server-1096082289128.europe-west1.run.app/api/demo-request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Origin': window.location.origin
                },
                body: JSON.stringify(formData)
            });
            
            const data = await response.json();
            
            if (!response.ok) {
                console.error('[DEMO ERROR] Request failed:', data);
                throw new Error(data.message || 'Failed to submit request');
            }
            
            console.log('[DEMO] Request successful:', data);
            
            // Track the form submission event
            trackEvent('demo_request', {
                form_name: 'demo_request_form'
            });
            
            // Show success message
            setSubmitStatus('success');
            
            // Navigate back to home after a delay
            setTimeout(() => {
                navigate('/');
            }, 3000);
        } catch (error) {
            console.error('[DEMO ERROR] Error:', error);
            setErrorMessage(error.message || 'There was an error submitting your request. Please try again.');
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main className="modern-layout">
            <div className="gradient_background">
                {/* Add plates image as background */}
                <img src={platesImage} alt="" className="background-plates" aria-hidden="true" />
                
                <div className="content-container">
                    <div className="demo-form-container">
                        <div className="form-header">
                            <BlurText
                                text="Request a Demo"
                                delay={100}
                                animateBy="words"
                                direction="top"
                                className="demo-title"
                            />
                            <p className="demo-subtitle">
                                Fill out the form below and we'll get in touch to schedule a personalized demo of Sophie AI.
                            </p>
                        </div>
                        
                        <form onSubmit={handleSubmit} className="demo-form">
                            <div className="form-group">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Your full name"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    placeholder="your.email@example.com"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="company">Company Name</label>
                                <input
                                    type="text"
                                    id="company"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                    placeholder="Your company name"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="phoneNumber">Phone Number (optional)</label>
                                <input
                                    type="tel"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="Your phone number"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="demoDetails">Tell us what you'd like to see in the demo</label>
                                <textarea
                                    id="demoDetails"
                                    name="demoDetails"
                                    value={formData.demoDetails}
                                    onChange={handleChange}
                                    required
                                    rows="5"
                                    placeholder="Please share any specific features or use cases you're interested in..."
                                />
                            </div>
                            
                            <button type="submit" className="submit-button" disabled={isSubmitting}>
                                {isSubmitting ? 'Sending...' : 'Request Demo'}
                            </button>
                            
                            {submitStatus === 'success' && (
                                <div className="success-message">
                                    Thank you for your request! We'll be in touch shortly to schedule your demo.
                                </div>
                            )}
                            
                            {submitStatus === 'error' && (
                                <div className="error-message">
                                    {errorMessage || 'There was an error submitting your request. Please try again or email us directly at hello@sophiedoc.ai.'}
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default RequestDemo;